export const brandConfigMap = new Map();

brandConfigMap.set('http://localhost:8080', 'vc-za-en');
brandConfigMap.set('http://192.168.88.149:8080', 'vc-za-en');
brandConfigMap.set('https://predictor-vodacomfantasy-com.migration.penrosesystems.com', 'vc-za-en');
brandConfigMap.set('http://192.168.88.112:8080', 'vc-za-en');
brandConfigMap.set('https://soccer-promotion-predictor-vodacomfantasy-com.migration.penrosesystems.com', 'vc-za-en');
brandConfigMap.set('https://demo-predictor-penrosegaming-com.migration.penrosesystems.com', 'vc-egy-ar')
brandConfigMap.set('https://demo-predictor-penrosegaming-com.migration.penrosesystems.com', 'vc-egy-ar')
brandConfigMap.set('default', 'vc-za-en');
